(() => {
  "use strict";

  var e = {
      353: e => {
        e.exports = require("@babel/runtime/helpers/slicedToArray");
      },
      4702: e => {
        e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
      },
      6689: e => {
        e.exports = require("react");
      },
      7518: e => {
        e.exports = require("styled-components");
      }
    },
    n = {};
  function t(r) {
    var o = n[r];
    if (void 0 !== o) return o.exports;
    var a = n[r] = {
      exports: {}
    };
    return e[r](a, a.exports, t), a.exports;
  }
  t.n = e => {
    var n = e && e.__esModule ? () => e.default : () => e;
    return t.d(n, {
      a: n
    }), n;
  }, t.d = (e, n) => {
    for (var r in n) t.o(n, r) && !t.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: n[r]
    });
  }, t.o = (e, n) => Object.prototype.hasOwnProperty.call(e, n), t.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var r = {};
  (() => {
    t.r(r), t.d(r, {
      default: () => g
    });
    var e,
      n,
      o,
      a,
      i = t(353),
      d = t.n(i),
      l = t(4702),
      p = t.n(l),
      s = t(6689),
      u = t.n(s),
      c = t(7518),
      f = t.n(c),
      b = f().div(e || (e = p()(["\n  width: 100%;\n"]))),
      v = f().div(n || (n = p()(["\n  width: 100%;\n"]))),
      m = f().button(o || (o = p()(["\n  /* reset properties */\n  outline: none;\n  border: none;\n  background: none;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: flex;\n"]))),
      y = f().div(a || (a = p()(["\n  width: 100%;\n"])));
    const g = function (e) {
      var n = e.header,
        t = e.content,
        r = e.id,
        o = e.initiallyOpen,
        a = e.onOpen,
        i = e.onClose,
        l = e.isOpenExternal,
        p = e.toggleExternal,
        c = e.dataTestId,
        f = (0, s.useState)(l || o || !1),
        g = d()(f, 2),
        x = g[0],
        O = g[1];
      return (0, s.useEffect)(function () {
        void 0 !== l && O(!!l);
      }, [l]), u().createElement(b, {
        "data-testid": c
      }, u().createElement(v, {
        role: "heading"
      }, u().createElement(m, {
        type: "button",
        onClick: function () {
          p ? p() : x ? (O(!1), i && i()) : (O(!0), a && a());
        },
        "aria-expanded": x ? "true" : "false",
        "aria-controls": r
      }, u().createElement(n, {
        isOpen: x
      }))), u().createElement(y, {
        id: r
      }, x && u().createElement(t, {
        isOpen: x
      })));
    };
  })();
  var o = exports;
  for (var a in r) o[a] = r[a];
  r.__esModule && Object.defineProperty(o, "__esModule", {
    value: !0
  });
})();